var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "recoveryUp" },
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.$t("addSurveyQuestionnaire"),
            visible: _vm.dialogShow
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: _vm.clearData
          }
        },
        [
          _c(
            "div",
            { ref: "containerRef", staticClass: "survey-form-container" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.rules,
                    "label-width": "100px",
                    size: "small"
                  }
                },
                [
                  _c(
                    "el-card",
                    {
                      staticClass: "section-card",
                      attrs: { header: _vm.$t("basicInfo") }
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("title"),
                                    prop: "title"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: _vm.$t("pleaseInputTitle")
                                    },
                                    model: {
                                      value: _vm.formData.title,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "title", $$v)
                                      },
                                      expression: "formData.title"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("description"),
                                    prop: "desc"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: _vm.$t("pleaseInputDesc")
                                    },
                                    model: {
                                      value: _vm.formData.desc,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "desc", $$v)
                                      },
                                      expression: "formData.desc"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "lodingItem",
                                  attrs: {
                                    prop: "start_time",
                                    rules: _vm.rules.start_time,
                                    label: _vm.$t("startTime")
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticClass: "flex-1 ",
                                    attrs: {
                                      "popper-class": "no-atTheMoment",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      placeholder: _vm.$t("pleaseChoose"),
                                      align: "right"
                                    },
                                    model: {
                                      value: _vm.formData.start_time,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "start_time",
                                          $$v
                                        )
                                      },
                                      expression: "formData.start_time"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "lodingItem",
                                  attrs: {
                                    prop: "end_time",
                                    rules: _vm.rules.end_time,
                                    label: _vm.$t("endTime")
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticClass: "flex-1 ",
                                    attrs: {
                                      "popper-class": "no-atTheMoment",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      placeholder: _vm.$t("pleaseChoose"),
                                      align: "right"
                                    },
                                    model: {
                                      value: _vm.formData.end_time,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "end_time", $$v)
                                      },
                                      expression: "formData.end_time"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("language"),
                                    prop: "language"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "flex-1",
                                      attrs: {
                                        clearable: "",
                                        filterable: "",
                                        placeholder: _vm.$t("pleaseChoose")
                                      },
                                      model: {
                                        value: _vm.formData.language,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "language",
                                            $$v
                                          )
                                        },
                                        expression: "formData.language"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("langChinese"),
                                          value: "cn"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("langEnglish"),
                                          value: "en"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("langAll"),
                                          value: "all"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("environment") } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "flex-1",
                                      attrs: {
                                        filterable: "",
                                        placeholder: _vm.$t("selectEnvironment")
                                      },
                                      on: { change: _vm.Renewal },
                                      model: {
                                        value: _vm.paramsData.is_prod,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.paramsData,
                                            "is_prod",
                                            $$v
                                          )
                                        },
                                        expression: "paramsData.is_prod"
                                      }
                                    },
                                    _vm._l(_vm.severlist, function(item) {
                                      return _c("el-option", {
                                        key: item.label,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("server"),
                                    prop: "server_range"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        multiple: "",
                                        "collapse-tags": "",
                                        filterable: "",
                                        clearable: "",
                                        placeholder: _vm.$t(
                                          "pleaseSelectServer"
                                        )
                                      },
                                      model: {
                                        value: _vm.formData.server_range,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "server_range",
                                            $$v
                                          )
                                        },
                                        expression: "formData.server_range"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "margin-left": "17px"
                                          },
                                          attrs: { size: "small" },
                                          on: { click: _vm.selectAllServers }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("selectAll")))]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "margin-left": "12px",
                                            "margin-bottom": "5px"
                                          },
                                          attrs: { size: "small" },
                                          on: { click: _vm.toggleInvertSelect }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("invertSelect")))]
                                      ),
                                      _vm._l(_vm.serverMergeList, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.serverID,
                                          attrs: {
                                            label: item.serverName,
                                            value: item.serverID
                                          }
                                        })
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("isLimit") } },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.formData.isLimit,
                                        callback: function($$v) {
                                          _vm.$set(_vm.formData, "isLimit", $$v)
                                        },
                                        expression: "formData.isLimit"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: false, border: "" } },
                                        [_vm._v(_vm._s(_vm.$t("no")))]
                                      ),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: true, border: "" } },
                                        [_vm._v(_vm._s(_vm.$t("yes")))]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 2 } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-plus",
                                    size: "small"
                                  },
                                  on: { click: _vm.addQuestion }
                                },
                                [_vm._v(_vm._s(_vm.$t("addQuestionLabel")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.formData.isLimit
                        ? [
                            _c(
                              "div",
                              { staticClass: "limit-box" },
                              _vm._l(_vm.formData.condition, function(
                                limit,
                                index
                              ) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "limit-item" },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "120px" },
                                        attrs: {
                                          placeholder: _vm.$t("conditionLabel")
                                        },
                                        model: {
                                          value: limit.k,
                                          callback: function($$v) {
                                            _vm.$set(limit, "k", $$v)
                                          },
                                          expression: "limit.k"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: _vm.$t("level"),
                                            value: "1",
                                            disabled: _vm.isOptionDisabled(
                                              1,
                                              index
                                            )
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: _vm.$t("vipRegistration"),
                                            value: "2",
                                            disabled: _vm.isOptionDisabled(
                                              5,
                                              index
                                            )
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: _vm.$t("passChapter"),
                                            value: "3",
                                            disabled: _vm.isOptionDisabled(
                                              2,
                                              index
                                            )
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: _vm.$t("language"),
                                            value: "4",
                                            disabled: _vm.isOptionDisabled(
                                              3,
                                              index
                                            )
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: _vm.$t(
                                              "cumulativeRechargeAmountShort"
                                            ),
                                            value: "5",
                                            disabled: _vm.isOptionDisabled(
                                              4,
                                              index
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("el-input", {
                                      staticStyle: {
                                        width: "150px",
                                        "margin-left": "10px"
                                      },
                                      attrs: {
                                        placeholder: _vm.$t("valueLabel")
                                      },
                                      model: {
                                        value: limit.v,
                                        callback: function($$v) {
                                          _vm.$set(limit, "v", $$v)
                                        },
                                        expression: "limit.v"
                                      }
                                    }),
                                    _vm.formData.condition.length > 1
                                      ? _c("el-button", {
                                          attrs: {
                                            icon: "el-icon-delete",
                                            type: "danger",
                                            circle: "",
                                            size: "mini"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeLimit(index)
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    index === _vm.formData.condition.length - 1
                                      ? _c("el-button", {
                                          attrs: {
                                            icon: "el-icon-plus",
                                            type: "primary",
                                            circle: "",
                                            size: "mini"
                                          },
                                          on: { click: _vm.addLimit }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          ]
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-top": "10px" },
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.addReward }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("addRewardConfig")) + " ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "limit-box-award",
                          staticStyle: { "margin-top": "5px" }
                        },
                        _vm._l(_vm.formData.award, function(reward, index) {
                          return _c(
                            "div",
                            {
                              key: "reward-" + index,
                              staticClass: "limit-item"
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: {
                                    "margin-bottom": "0",
                                    "margin-left": "8px"
                                  },
                                  attrs: {
                                    prop: "award." + index + ".id",
                                    "label-width": "0"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "120px" },
                                    attrs: {
                                      placeholder: _vm.$t("itemIdLabel")
                                    },
                                    model: {
                                      value: reward.id,
                                      callback: function($$v) {
                                        _vm.$set(reward, "id", $$v)
                                      },
                                      expression: "reward.id"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { "margin-bottom": "0" },
                                  attrs: {
                                    prop: "award." + index + ".num",
                                    "label-width": "0"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: {
                                      width: "150px",
                                      "margin-left": "10px"
                                    },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "itemQuantityPlaceholder"
                                      )
                                    },
                                    model: {
                                      value: reward.num,
                                      callback: function($$v) {
                                        _vm.$set(reward, "num", $$v)
                                      },
                                      expression: "reward.num"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("el-button", {
                                attrs: {
                                  icon: "el-icon-delete",
                                  type: "danger",
                                  circle: "",
                                  size: "mini"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeReward(index)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ],
                    2
                  ),
                  _c(
                    "div",
                    {
                      ref: "questionSectionRef",
                      staticClass: "question-section"
                    },
                    [
                      _c("div", { staticClass: "section-header" }, [
                        _c("h3", [_vm._v(_vm._s(_vm.$t("questionConfig")))])
                      ]),
                      _c(
                        "div",
                        { staticClass: "question-scroll-container" },
                        _vm._l(_vm.formData.questions, function(q, qIndex) {
                          return _c(
                            "div",
                            { key: qIndex, staticClass: "question-card" },
                            [
                              _c(
                                "div",
                                { staticClass: "q-header" },
                                [
                                  _c("span", { staticClass: "q-number" }, [
                                    _vm._v("Q" + _vm._s(qIndex + 1))
                                  ]),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "#F56C6C" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeQuestion(qIndex)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("deleteQuestion")))]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t("questionTitle"),
                                            prop:
                                              "questions." + qIndex + ".title",
                                            rules: _vm.rules.title
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value: q.title,
                                              callback: function($$v) {
                                                _vm.$set(q, "title", $$v)
                                              },
                                              expression: "q.title"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 4 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t("isRequired"),
                                            prop:
                                              "questions." +
                                              qIndex +
                                              ".required",
                                            rules: _vm.rules.required
                                          }
                                        },
                                        [
                                          _c("el-switch", {
                                            model: {
                                              value: q.required,
                                              callback: function($$v) {
                                                _vm.$set(q, "required", $$v)
                                              },
                                              expression: "q.required"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t("type"),
                                            prop:
                                              "questions." + qIndex + ".type",
                                            rules: _vm.rules.type
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              on: {
                                                change: function($event) {
                                                  return _vm.handleTypeChange(q)
                                                }
                                              },
                                              model: {
                                                value: q.type,
                                                callback: function($$v) {
                                                  _vm.$set(q, "type", $$v)
                                                },
                                                expression: "q.type"
                                              }
                                            },
                                            [
                                              _c("el-option", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "choiceQuestion"
                                                  ),
                                                  value: "1"
                                                }
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "fillBlankQuestion"
                                                  ),
                                                  value: "2"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("div", { staticClass: "type-detail-area" }, [
                                q.type == "1"
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t("optionalCount")
                                            }
                                          },
                                          [
                                            _c("el-input-number", {
                                              attrs: { min: 1, size: "small" },
                                              model: {
                                                value: q.max_select,
                                                callback: function($$v) {
                                                  _vm.$set(q, "max_select", $$v)
                                                },
                                                expression: "q.max_select "
                                              }
                                            }),
                                            _c("span", { staticClass: "tip" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "notGreaterThanOptionTotal"
                                                  )
                                                )
                                              )
                                            ]),
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: {
                                                  "font-size": "14px",
                                                  "margin-left": "5px"
                                                },
                                                attrs: {
                                                  type: "text",
                                                  icon:
                                                    "el-icon-circle-plus-outline"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return q.options.push({
                                                      desc: "",
                                                      type: 1
                                                    })
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("addOption"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "options-list" },
                                          _vm._l(q.options, function(
                                            opt,
                                            oIndex
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: oIndex,
                                                staticClass: "option-item"
                                              },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop:
                                                        "questions." +
                                                        qIndex +
                                                        ".options." +
                                                        oIndex +
                                                        ".desc",
                                                      rules: _vm.rules.desc
                                                    }
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        width: "300px"
                                                      },
                                                      attrs: {
                                                        placeholder: _vm.$t(
                                                          "optionContent"
                                                        )
                                                      },
                                                      model: {
                                                        value: opt.desc,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            opt,
                                                            "desc",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "opt.desc"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    staticClass: "select-item",
                                                    attrs: {
                                                      "label-width": "0",
                                                      prop:
                                                        "questions." +
                                                        qIndex +
                                                        ".options." +
                                                        oIndex +
                                                        ".type",
                                                      rules: _vm.rules.type
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          height: "32px",
                                                          width: "90px"
                                                        },
                                                        model: {
                                                          value: opt.type,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              opt,
                                                              "type",
                                                              $$v
                                                            )
                                                          },
                                                          expression: "opt.type"
                                                        }
                                                      },
                                                      [
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "selectItem"
                                                            ),
                                                            value: 1
                                                          }
                                                        }),
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "selectThenFill"
                                                            ),
                                                            value: 3
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                opt.type == 3
                                                  ? [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "minWordCount"
                                                            ),
                                                            prop:
                                                              "questions." +
                                                              qIndex +
                                                              ".options." +
                                                              oIndex +
                                                              ".word_limit_min",
                                                            rules:
                                                              _vm.rules
                                                                .word_limit_min
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              attrs: { min: 1 },
                                                              model: {
                                                                value:
                                                                  opt.word_limit_min,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    opt,
                                                                    "word_limit_min",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "opt.word_limit_min"
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "maxWordCount"
                                                            ),
                                                            prop:
                                                              "questions." +
                                                              qIndex +
                                                              ".options." +
                                                              oIndex +
                                                              ".word_limit_max",
                                                            rules:
                                                              _vm.rules
                                                                .word_limit_max
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              attrs: {
                                                                type: "number",
                                                                min: 1
                                                              },
                                                              model: {
                                                                value:
                                                                  opt.word_limit_max,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    opt,
                                                                    "word_limit_max",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "opt.word_limit_max"
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  : _vm._e(),
                                                q.options.length > 1
                                                  ? _c("el-button", {
                                                      staticStyle: {
                                                        "margin-top": "-12px"
                                                      },
                                                      attrs: {
                                                        icon: "el-icon-delete",
                                                        type: "danger",
                                                        circle: "",
                                                        size: "mini"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return q.options.splice(
                                                            oIndex,
                                                            1
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          }),
                                          0
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                q.type == "2"
                                  ? _c(
                                      "div",
                                      _vm._l(q.options, function(opt, oIndex) {
                                        return _c(
                                          "div",
                                          { key: oIndex },
                                          [
                                            _c(
                                              "el-row",
                                              { attrs: { gutter: 20 } },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 8 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "tipText"
                                                          ),
                                                          prop:
                                                            "questions." +
                                                            qIndex +
                                                            ".options." +
                                                            oIndex +
                                                            ".desc",
                                                          rules: _vm.rules.desc
                                                        }
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          attrs: {
                                                            placeholder: _vm.$t(
                                                              "pleaseInputTipContent"
                                                            )
                                                          },
                                                          model: {
                                                            value: opt.desc,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                opt,
                                                                "desc",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "opt.desc"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 4 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "minWordCount"
                                                          ),
                                                          prop:
                                                            "questions." +
                                                            qIndex +
                                                            ".options." +
                                                            oIndex +
                                                            ".word_limit_min",
                                                          rules:
                                                            _vm.rules
                                                              .word_limit_min
                                                        }
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            type: "number"
                                                          },
                                                          model: {
                                                            value:
                                                              opt.word_limit_min,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                opt,
                                                                "word_limit_min",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "opt.word_limit_min"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 4 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "maxWordCount"
                                                          ),
                                                          prop:
                                                            "questions." +
                                                            qIndex +
                                                            ".options." +
                                                            oIndex +
                                                            ".word_limit_max",
                                                          rules:
                                                            _vm.rules
                                                              .word_limit_max
                                                        }
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            type: "number"
                                                          },
                                                          model: {
                                                            value:
                                                              opt.word_limit_max,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                opt,
                                                                "word_limit_max",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "opt.word_limit_max"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e()
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "footer-btns" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.dialogShow = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", disabled: _vm.isdisabled },
                      on: { click: _vm.submitForm }
                    },
                    [_vm._v(_vm._s(_vm.$t("saveSubmit")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }